import { useContext } from 'react';

// auth provider
import AuthContext from 'contexts/AuthContext';
import { AuthContextType } from 'types/auth';

// ==============================|| AUTH HOOKS ||============================== //

const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
};

export default useAuth;
